/*!

=========================================================
* Black Dashboard React v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Home from "views/Home.js";
import Landing from "views/Landing.js";
import Presentation from "views/Presentation";
import RoboVip from "views/RoboVip";
import MyLinks from "views/MyLinks";
import Mentoria from "views/Mentoria";
import Login from "views/Login";
import Register from "views/Register";
import Deposits from "views/Deposit";
import Withdraw from "views/Withdraw";
import GamesSignal from "views/GamesSignal";
import Mines from "views/Mines";
import AviatorPRO from "views/AviatorPRO";
import Football from "views/Football";
import Bacboo from "views/Bacboo";
import AviatorCombined from "views/AviatorCombined";
import ForgotPassword from "views/ForgotPassword";
import Aulas from "views/Aulas";
import Promotions from "views/Promotions";
import Roletas from "views/Roletas";
import AdminPanel from "views/AdminPanel";

// https://images.cometagaming.com/96df8b94-8149-41fe-694c-8973e30b6500/desktop
var routes = [
  {
    path: "/admin-panel",
    name: "Admin Panel",
    rtlName: "لوحة القيادة",
    icon: "fa fa-user-shield",
    component: AdminPanel,
    layout: "/admin"
  },
  {
    path: "/history-aviator",
    name: "Histórico",
    rtlName: "لوحة القيادة",
    icon: "tim-icons icon-chart-pie-36",
    component: Home,
    layout: "/admin",
    showInBottom: true
  },
  {
    path: "/horarios",
    name: "Minutagem",
    rtlName: "لوحة القيادة",
    icon: "fa fa-star",
    component: AviatorPRO,
    layout: "/admin",
    showInBottom: true
  },
  {
    path: "/aulas",
    name: "Aulas",
    icon: "fa fa-chalkboard-teacher",
    component: Aulas,
    layout: "/admin",
    showInBottom: true
  },
  {
    path: "/promos",
    name: "Promoções",
    icon: "fa fa-gift", // promoções, bônus
    component: Promotions,
    layout: "/admin",
    showInBottom: true
  },
  {
    path: "/deposit",
    name: "Depositar",
    rtlName: "لوحة القيادة",
    icon: "fa fa-chevron-up",
    component: Deposits,
    layout: "/admin"
  },
  {
    path: "/withdraw",
    name: "Sacar",
    rtlName: "لوحة القيادة",
    icon: "fa fa-chevron-down",
    component: Withdraw,
    layout: "/admin"
  },
  {
    path: "/login",
    name: "Login",
    rtlName: "لوحة القيادة",
    icon: "tim-icons icon-chart-pie-36",
    component: Login,
    layout: "/auth",
    redirect: true
  },
  {
    path: "/20reais",
    name: "ACESSO VIP PARA O APLICATIVO",
    rtlName: "لوحة القيادة",
    icon: "fa fa-home",
    component: Landing,
    layout: "/offer",
    redirect: true
  },
  {
    path: "/forgot-password",
    name: "Esqueci minha senha",
    rtlName: "لوحة القيادة",
    component: ForgotPassword,
    layout: "/auth",
    redirect: true,
    icon: "tim-icons icon-chart-pie-36"
  },
  {
    path: "/register/:role",
    name: "Register",
    rtlName: "لوحة القيادة",
    icon: "tim-icons icon-chart-pie-36",
    component: Register,
    layout: "/auth",
    redirect: true
  },
  {
    path: "/presentation",
    name: "Apresentação",
    rtlName: "لوحة القيادة",
    icon: "tim-icons icon-chart-pie-36",
    component: Presentation,
    layout: "/auth",
    redirect: true
  },
  {
    path: "/my-links",
    name: "Meus Links",
    rtlName: "لوحة القيادة",
    icon: "tim-icons icon-chart-pie-36",
    component: MyLinks,
    layout: "/auth",
    redirect: true
  },
  {
    path: "/mentoria",
    name: "Mentoria",
    rtlName: "لوحة القيادة",
    icon: "tim-icons icon-chart-pie-36",
    component: Mentoria,
    layout: "/auth",
    redirect: true
  },
  {
    path: "/bot-teleco-vip",
    name: "Robo VIP",
    rtlName: "لوحة القيادة",
    icon: "tim-icons icon-chart-pie-36",
    component: RoboVip,
    layout: "/auth",
    redirect: true
  }
];
export default routes;
